angular.module('inspecciones')
    .controller('damageController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, infraestructurasAdminService, authenticationInfo, authenticationService) {

            $scope.authentication = authenticationInfo;
            //$scope.InfraestructuraId = $routeParams.idInfraestructura;           


            $scope.InspeccionId = $routeParams.idInspeccion;

            $scope.pestanyamenuinspeccion = 'general';

            $scope.indice = 0;

            $scope.IdDaño = $routeParams.id;


            infraestructurasAdminService.getInspectores()
                .then(function (response) {
                    var data = response.data;
                    $scope.inspectores = data;

                    infraestructurasAdminService.getTiposDaño()
                        .then(function (response) {
                            data = response.data;
                            $scope.tipos = data;

                            infraestructurasAdminService.getElementos()
                                .then(function (response) {
                                    data = response.data;
                                    $scope.elementos = data;

                                    inspeccionesService.getCategoriasDaño()
                                        .then(function (response) {
                                            var data = response.data;
                                            $scope.categorias = data;

                                            infraestructurasAdminService.getIntensidades()
                                                .then(function (response) {
                                                    var data = response.data;
                                                    $scope.intensidades = data;

                                                    infraestructurasAdminService.getEvoluciones()
                                                        .then(function (response) {
                                                            var data = response.data;
                                                            $scope.evoluciones = data;

                                                            inspeccionesService.getDaño($scope.IdDaño)
                                                                .then(function (response) {
                                                                    var data = response.data;
                                                                    $scope.damage = data;

                                                                    inspeccionesService.getImagen($scope.IdDaño)
                                                                        .then(function (response) {
                                                                            var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                                                                            var imageUrl = URL.createObjectURL(blob);
                                                                            $scope.imagenSrc = imageUrl;
                                                                        });
                                                                });
                                                        });
                                                });

                                        });
                                });
                        });
                });


            $scope.volver = function () {
                //$rootScope.inspeccionUrl = true;
                $rootScope.damageUrl = true;
                $location.path('/inspecciones/' + $scope.InspeccionId);
            }


            $scope.verHistorial = function () {
                $location.path('/inspecciones/historial/' + $scope.InspeccionId + '/' + $scope.IdDaño);
            }

            $scope.verEvolucion = function () {
                $location.path('/inspecciones/evolucion/' + $scope.InspeccionId + '/' + $scope.IdDaño);
            }


            $scope.guardar = function () {
                $scope.damage.CategoriaDañoId = $scope.damage.CategoriaId;
                $scope.damage.EvolucionDañoId = $scope.damage.EvolucionId;
                $scope.damage.TipoDañoId = $scope.damage.TipoId;
                $scope.damage.IntensidadDañoId = $scope.damage.IntensidadId;
                $scope.damage.PkDaño = $scope.damage.PkDano;
                if ($scope.damage.CoordenadaX == null || $scope.damage.CoordenadaX == undefined || $scope.damage.CoordenadaX == "") {
                    alert("El campo Coordenada X es obligatorio");
                } else if ($scope.damage.CoordenadaY == null || $scope.damage.CoordenadaY == undefined || $scope.damage.CoordenadaY == "") {
                    alert("El campo Coordenada X es obligatorio");
                } else if ($scope.damage.IntensidadDañoId == null || $scope.damage.IntensidadDañoId == undefined) {
                    alert("El campo Intensidad es obligatorio");
                } else if ($scope.damage.ElementoId == null || $scope.damage.ElementoId == undefined) {
                    alert("El campo Elemento es obligatorio");
                } else if ($scope.damage.InspectorId == null || $scope.damage.InspectorId == undefined) {
                    alert("El campo Inspector es obligatorio");
                } else if ($scope.damage.TipoId == null || $scope.damage.TipoId == undefined) {
                    alert("El campo Tipo es obligatorio");
                } else if ($scope.damage.EvolucionId == null || $scope.damage.EvolucionId == undefined) {
                    alert("El campo Evolucion es obligatorio");
                } else {
                    inspeccionesService.guardarDaño($scope.damage)
                        .then(function (response) {
                            var data = response.data;
                            //$scope.damage.ElementoId = data.daño.ElementoId;
                            $scope.damage.CategoriaId = data.daño.CategoriaDaño.Id;
                            //$scope.damage.EvolucionId = $scope.damage.EvolucionDañoId;
                            //$scope.damage.TipoId = $scope.damage.TipoDañoId;
                            //$scope.damage.IntensidadId = $scope.damage.IntensidadDañoId;
                            $scope.damage.PkDano = data.daño.PkDaño;
                            alert("Daño guardado correctamente")
                        });
                }
            };


            $scope.$watch('damage.PkDano', function (newVal) {
                if (newVal != null) {
                    const str = newVal.toString().padStart(4, '0');
                    $scope.damage.PkDanoFormatted = str.slice(0, 1) + '/' + str.slice(1);
                }
            });


            $scope.logout = function () {
                //$rootScope.bodylayout = "login";
                return authenticationService.logout();
            }

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
        }
    ]);